/* globals Swiper */
import Swiper from 'swiper';
import { Navigation, Pagination, A11y, Mousewheel } from 'swiper/modules';
import 'swiper/css';
import { sliderPagination } from '~/js/helpers';

function initCardReadMore(container) {
	container.querySelectorAll('[data-card-read-more]').forEach((readMoreButton) => {
		if (readMoreButton.dataset.readMoreBound === 'true') {
			return;
		}

		readMoreButton.dataset.readMoreBound = 'true';

		const card = readMoreButton.closest('.card-team, .card-default, .card-vacancy');

		if (!card) {
			return;
		}

		const text = card.querySelector('[data-card-text]');
		const readLessButton = card.querySelector('[data-card-read-less]');

		if (!text || !readLessButton) {
			return;
		}

		readMoreButton.addEventListener('click', () => {
			text.classList.remove('is-collapsed');
			readMoreButton.classList.add('hidden');
			readLessButton.classList.remove('hidden');
			readMoreButton.setAttribute('aria-expanded', 'true');
			readLessButton.setAttribute('aria-expanded', 'true');
		});

		readLessButton.addEventListener('click', () => {
			text.classList.add('is-collapsed');
			readLessButton.classList.add('hidden');
			readMoreButton.classList.remove('hidden');
			readMoreButton.setAttribute('aria-expanded', 'false');
			readLessButton.setAttribute('aria-expanded', 'false');
		});
	});
}

const featuredItems = [...document.querySelectorAll('.featured-items')];

featuredItems.forEach((featuredItem) => {
	initCardReadMore(featuredItem);
	const featuredSlider = featuredItem.querySelector('.swiper-featured-items');
	if (!featuredSlider) return;

	const slidesPerView = Number(featuredSlider.dataset.swiperColumns) || 4;

	// Determine the default gap value from CSS variables or fallback to a default value
	var style = window.getComputedStyle(document.body);
	let defaultGap = style.getPropertyValue('--gap-auto');
	if (defaultGap && defaultGap.includes('rem')) {
		const remValue = parseFloat(defaultGap);
		const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
		defaultGap = `${remValue * rootFontSize}px`;
	}
	if (!defaultGap || defaultGap.trim() === '') {
		defaultGap = '32px';
	}

	new Swiper(featuredSlider, {
		modules: [Navigation, Pagination, A11y, Mousewheel],
		a11y: true,
		grabCursor: true,
		loop: false,
		slidesPerView: 1.05,
		spaceBetween: defaultGap,
		keyboard: {
			enabled: true,
		},
		navigation: {
			nextEl: featuredSlider.querySelector('.swiper-button-next'),
			prevEl: featuredSlider.querySelector('.swiper-button-prev'),
		},
		pagination: sliderPagination(featuredSlider.querySelector('.swiper-pagination')),
		breakpoints: {
			760: {
				slidesPerView: 2,
				spaceBetween: 32,
			},
			1280: {
				slidesPerView,
			},
		},
		mousewheel: {
			enabled: true,
			forceToAxis: true,
		},
	});
});
